import React from 'react'

import FeedItem from 'js/components/FeedItem/FeedItem'
import FeedItemContent from 'js/components/FeedItem/FeedItemContent'
import FeedItemFooter from 'js/components/FeedItem/FeedItemFooter'
import FeedItemImage from 'js/components/FeedItem/FeedItemImage'

const Card = ({
    'data-feed': dataFeed,
    entity,
    canPin,
    excerptMaxLines,
    hideActions,
    hideAuthor,
    hideComments,
    hideExcerpt,
    hideGroup,
    hideLikes,
    hidePublishDate,
    hideBookmark,
    hideSubtype,
}) => {
    const { guid, group, contentType } = entity
    const { slug, listViewTemplateIds } = contentType

    const onEdit = `${group ? group.url : ''}/${slug}/edit/${guid}`

    const options = {
        author: listViewTemplateIds.includes('author'),
        publishDate: listViewTemplateIds.includes('publishDate'),
        excerpt: listViewTemplateIds.includes('excerpt'),
        save: listViewTemplateIds.includes('save'),
        likes: listViewTemplateIds.includes('likes'),
        comments: listViewTemplateIds.includes('comments'),
    }

    return (
        <FeedItem data-feed={dataFeed}>
            <FeedItemContent
                entity={entity}
                canPin={canPin}
                excerptMaxLines={excerptMaxLines}
                hideActions={hideActions}
                hideAuthor={hideAuthor || !options.author}
                hideExcerpt={hideExcerpt || !options.excerpt}
                hideGroup={hideGroup}
                hidePublishDate={hidePublishDate || !options.publishDate}
                hideBookmark={hideBookmark || !options.save}
                hideSubtype={hideSubtype}
                onEdit={onEdit}
                refetchQueries={['ActivityList']}
            />
            <FeedItemFooter
                entity={entity}
                hideComments={hideComments || !options.comments}
                hideLikes={hideLikes || !options.likes}
            />
            <FeedItemImage entity={entity} />
        </FeedItem>
    )
}

export default Card
